import * as core from '../../../../../../../core'
import * as cursorTracker from '../cursor-tracker'

export const RESOURCE = {
  payload: {
    alias: 'cursor-events',
    appAlias: cursorTracker.RESOURCE.payload.alias,
    description: 'Browse all recorded Cursor usage events.',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Cursor Events',
    page: { alias: 'cursor-events' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
